import { getDefaultClient } from '../../factory';
// @endpoint GET /apps/:id
// @controller UserAction.AppDetail
export async function getAppDetail(id) {
    return getDefaultClient().get(`/apps/${id}`);
}
// @endpoint GET /dataset/:id/:node_id
// @controller UserAction.GetDataset
export async function getDataset(id, nodeId) {
    return getDefaultClient().get(`/dataset/${id}/${nodeId}`);
}
// @endpoint POST /organization/departments/tree
// @controller UserAction.GetOrganizationTree
export async function getOrganizationTree(data) {
    return getDefaultClient().post('/organization/departments/tree', data);
}
// @endpoint POST /organization/users
// @controller UserAction.GetOrganizationUsers
export async function getOrganizationUsers(data) {
    return getDefaultClient().post('/organization/users', data);
}
// @endpoint POST /upload/token
// @controller UserAction.GetUploadToken
export async function getUploadToken(data) {
    return getDefaultClient().post('/upload/token', data);
}
// @endpoint GET /ingress/:app_id/:ingress_id
// @controller UserAction.Ingress
export async function getIngress(appId, ingressId) {
    return getDefaultClient().get(`/ingress/${appId}/${ingressId}`);
}
// @endpoint PUT /ingress/:app_id/:ingress_id/options-tabber
// @controller UserAction.IngressSetOptionsTabber
export async function setIngressOptionsTabber(appId, ingressId, data) {
    return getDefaultClient().put(`/ingress/${appId}/${ingressId}/options-tabber`, data);
}
// @endpoint POST /upload/mobile-upload
// @controller UserAction.MobileUpload
export async function mobileUpload(data) {
    return getDefaultClient().post('/upload/mobile-upload', data);
}
// @endpoint POST /upload/mobile-upload/check
// @controller UserAction.MobileUploadCheck
export async function checkMobileUpload(data) {
    return getDefaultClient().post('/upload/mobile-upload/check', data);
}
// @endpoint POST /upload/preview
// @controller UserAction.UploadPreview
export async function uploadPreview(data) {
    return getDefaultClient().post('/upload/preview', data);
}
// @endpoint POST /entity/:app_id/:entity_id/validate-uniq
// @controller UserAction.EntityValidateUniq
export async function validateEntityUnique(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/validate-uniq`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/query-rel
// @controller UserAction.EntityQueryRelation
export async function queryEntityRelation(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-rel`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/query-linkto-pick
// @controller UserAction.EntityQueryLinkToPick
export async function queryLinktoPickOptions(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-linkto-pick`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/query-linkto-values
// @controller UserAction.EntityQueryLinkToValues
export async function queryLinktoValues(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-linkto-values`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/query-subform-rel
// @controller UserAction.EntityQuerySubformRelation
export async function getSubformRelationData(appId, entityId, options) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/query-subform-rel`, options);
}
